import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router';

const PublicRoutes = ({ isAuthenticate, component: Component, ...rest }) => {
    return (
        <Route { ...rest } component={
            (props) => (isAuthenticate) ?  <Redirect to="/dashboard"/> : <Component {...props} />
        } />
    );
}

PublicRoutes.propTypes = {
    isAuthenticate: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}

export default PublicRoutes;
